import client from 'api/client';
import { AxiosResponse } from 'axios';

export function get(id: number): Promise<AxiosResponse> {
    const url = `/all_candidate_info/${id}`;
    return client.get(url);
}
